/**
 * Palette des couleurs de notes, reprise de Google Keep.
 * Le serveur ne stocke que l'identifiant ; le rendu (clair/sombre) est l'affaire du front.
 */
export const NOTE_COLORS = [
  'default',
  'coral',
  'peach',
  'sand',
  'mint',
  'sage',
  'fog',
  'storm',
  'dusk',
  'blossom',
  'clay',
  'chalk',
] as const;

export type NoteColor = (typeof NOTE_COLORS)[number];

export const NOTE_COLOR_LABELS: Record<NoteColor, string> = {
  default: 'Par défaut',
  coral: 'Corail',
  peach: 'Pêche',
  sand: 'Sable',
  mint: 'Menthe',
  sage: 'Sauge',
  fog: 'Brume',
  storm: 'Orage',
  dusk: 'Crépuscule',
  blossom: 'Fleur',
  clay: 'Argile',
  chalk: 'Craie',
};
